export default __webpack_public_path__ + "static/media/monsterDeath.a6e06d1e.mp3";